import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";


import "./assets/style/style.scss";
import "./assets/style/color.scss";
import "./assets/style/fonts.scss";
import "./assets/style/heights.scss";
import "./assets/style/widths.scss";
import "./assets/style/responsive.scss";
import "./assets/style/custome.scss";

import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./Screen/Auth/Login/Login";
import Welcome from "./Screen/Auth/Welcome/Welcome";
import MainPage from "./Screen/Auth/MainPage/MainPage";
import Register from "./Screen/Auth/Register/Register";
import Layout from "./Components/Layout/Layout";
import PrivateRoutes from "./Components/PrivateRouter/PrivateRouter";

import Profile from "./Screen/Profile/Profile";
import Attendance from "./Screen/Attendance/Attendance";
import TimeSheet from "./Screen/TimeSheet/TimeSheet";
import Payroll from "./Screen/Payroll/Payroll";
import AdminLayout from "./Components/Layout/AdminLayout";
import Admin from "./Screen/Admin/Admin/Admin";
import AdminAddEdit from "./Screen/Admin/Admin/AdminAdd";
import Employees from "./Screen/Admin/Employee/Employees";
import AddEmployee from "./Screen/Admin/Employee/AddEmployee";
import EmployeeDocuments from "./Screen/Admin/DetailsUpload/EmployeeDocuments";
import PayslipGenerated from "./Screen/Admin/PayslipGenerated/PayslipGenerated";
import EmployeeDocumentView from "./Screen/EmployeeDocumentView/EmployeeDocumentView";
import EmployeeDashboard from "./Screen/Dashboard/Dashboard";
import AdminPendingList from "./Screen/Admin/Confirm/AdminPendingList";
import AdminDashboard from "./Screen/Admin/Dashboard/Dashboard";
import AdminAttandence from "./Screen/Admin/AttandanceDetails/AdminAttandence";
import SendDetails from "./Screen/Admin/DetailsUpload/SendDetails";
import SalaryDetails from "./Screen/SalaryDetails/SalaryDetails";
import CreateSalaryDetails from "./Screen/Admin/AdminSalary/CreateSalaryDetails";
import AdminSalary from "./Screen/Admin/AdminSalary/AdminSalaryCreate";
import AllEmployeeSalary from "./Screen/Admin/AllEmployeeSalary/AllEmployeeSalary";
import EmployeeSalary from "./Screen/Employee-Salary-Details/EmployeeSalary";
import OfferLetterGenerated from "./Screen/Admin/OfferLetterGenerated/OfferLetterGenerated";
import RelievingLetter from "./Screen/Admin/RelievingLetter/RelievingLetter";
import Employeeloginhistory from "./Screen/Admin/AttandanceDetails/Employeeloginhistory";

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/main-page" element={<MainPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            {/* ADMIN ROUTES */}
            <Route element={<PrivateRoutes allowedRoles={["admin", "superadmin"]} />}>
                <Route element={<AdminLayout />}>
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/Admin" element={<Admin />} />
                    <Route path="/admin/add" element={<AdminAddEdit />} />
                    <Route path="/admin/edit/:id" element={<AdminAddEdit />} />
                    <Route path="/employees-list" element={<Employees />} />
                    <Route path="/employee/add" element={<AddEmployee />} />
                    <Route path="/employee/edit/:id" element={<AddEmployee />} />
                    <Route path="/employeedocument" element={<EmployeeDocuments />} />
                    <Route path="/employee-documents-sent" element={<SendDetails />} />
                    <Route path="/payslip-generated" element={<PayslipGenerated />} />
                    <Route path="/offer-letter-generated" element={<OfferLetterGenerated />} />
                    <Route path="/relieving-letter-generated" element={<RelievingLetter />} />
                    <Route path="/admin-pending-list" element={<AdminPendingList />} />
                    <Route path="/attendance-list" element={<AdminAttandence />} />
                    <Route path="/employee-login-history/:id" element={<Employeeloginhistory />} />
                    <Route path="/salary-detail-list" element={<AdminSalary />} />
                    <Route path="/create-salary-details" element={<CreateSalaryDetails />} />
                    <Route path="/create-salary-details/:id" element={<CreateSalaryDetails />} />
                    <Route path="/all-employee-salary" element={<AllEmployeeSalary />} />

                </Route>
            </Route>

            <Route element={<PrivateRoutes allowedRole={["employee"]} />}>
                <Route element={<Layout />}>
                    <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/register-view/:id" element={<Register />} />
                    <Route path="/attendance" element={<Attendance />} />
                    <Route path="/time-sheet" element={<TimeSheet />} />
                    <Route path="/document-view" element={<EmployeeDocumentView />} />
                    <Route path="/payroll" element={<Payroll />} />
                    <Route path="/salary-details" element={<SalaryDetails />} />
                    <Route path="/employee-salary-list" element={<EmployeeSalary />} />


                </Route>
            </Route>
        </Routes>
    );
};

export default AppRouter;
